import { block, lines } from '../../../assets/js/modules/_animations.js';

document.querySelectorAll( '.page-intro' ).forEach( node => {
	lines( node.querySelectorAll( '.wp-block-pullquote p' ) );
	block( node.querySelector( '.wp-block-columns > .wp-block-column:nth-child(2)' ), { delay: 200 } );
} );
